// extracted by mini-css-extract-plugin
module.exports = {"container":"WorkersACRowDetail_container__1MXcy","childContainer":"WorkersACRowDetail_childContainer__2_TWz","workerPhoto":"WorkersACRowDetail_workerPhoto__1Wnar"};